<template>
<div class="column is-full">
    <div>        
        <div class="card-header">
            <p class="card-header-title">Options</p>
        </div>
        <div class="card-content">                
            <div class="columns">
                <div class="column is-6">
                    Maximum number of backdate (in days) parents can select when doing submissions:
                </div>
                <div class="column is-6">
                    <input class="input is-success" type="number" placeholder="How many days to allow backdate to" v-model="parentSubmissionMinDuration">
                </div>
            </div>
            <div class="columns">
                <div class="column is-full">
                    <button class='button is-primary' v-on:click="updateOptions()">Update Options</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components:{
        Loading,
    },
    data() {
        return {
            newDataType: 1,
            schoolID: "",
            parentSubmissionMinDurationType: 1,
            parentSubmissionMinDuration: 7
        };
    },
    created() {
        // this.getTeacherList();
        // this.getTagList();
        this.schoolID = localStorage.getItem('schoolID');
        this.getBehaviorOptions()
    },
    methods: {
        getBehaviorOptions(){
            let self = this
            self.isLoading = true
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/schoolV2/info', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                if (response.data.parentSubmissionMinDurationType){
                    self.parentSubmissionMinDurationType = parseInt(response.data.parentSubmissionMinDurationType)
                    if (response.data.parentSubmissionMinDuration){
                        self.parentSubmissionMinDuration = parseInt(response.data.parentSubmissionMinDuration)
                    }else{
                        self.parentSubmissionMinDuration = 7
                    }
                }else{
                    self.parentSubmissionMinDurationType = 1
                }
            })
            .catch(e => {
                console.log(e)
            })
        },
        updateOptions(data) {
            let self = this;

            var parentSubmissionMinDuration = parseInt(self.parentSubmissionMinDuration);

            if (parentSubmissionMinDuration < 1){
                Toast.open({
                    message: "Please enter the number of days to allow backdate to",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            axios.defaults.responseType = 'json'     
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/optionsUpdate/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                dataType: 4,
                parentSubmissionMinDuration: self.parentSubmissionMinDuration
            })
            .then(response => {
                console.log("99")
                console.log(response.data)
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }
            })
            .catch(e => {
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
    },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Manage/Behaviors/OptionsParentsView.vue